import { last } from 'lodash';

/**
 * Assets
 *
 * A quick helper for retrieving assets.
 */
export default class Assets {
  static getShippingLabelUrl(chainId, instructions) {
    if (instructions === undefined) {
      return `/portfolio/shippinglabel/${chainId}`;
    }

    return `/portfolio/shippinglabel/${chainId}?instructions=on`;
  }

  static baseSkinPath() {
    return 'https://stockx-assets.imgix.net';
  }

  static getUrl(assetPath: string, additionalParams = '') {
    if (!assetPath.includes('contentstack')) {
      return `${
        Assets.baseSkinPath() +
        (assetPath.indexOf('/') === 0 ? assetPath : `/${assetPath}`)
      }?auto=compress,format${additionalParams}`;
    }

    const fileFormat = last(assetPath.split('.'))?.substr(0, 3);

    return `${assetPath}?auto=webp&format=${fileFormat}`;
  }

  static getPaymentMethodUrl(assetPath, additionalParams = '') {
    return `${
      Assets.baseSkinPath() +
      (assetPath.indexOf('/') === 0
        ? `/png/payment-methods${assetPath}`
        : `/png/payment-methods/${assetPath}`)
    }?auto=compress,format${additionalParams}`;
  }

  static getTrackingUrl(number) {
    return `http://wwwapps.ups.com/etracking/tracking.cgi?tracknum=${number}`;
  }

  static baseCatalogPath() {
    return '/media/catalog/product';
  }

  static getCatalogUrl(path) {
    if (
      path == null ||
      !path ||
      path === 'no_selection' ||
      path.includes('New-Product-Placeholder-Default')
    ) {
      return Assets.getUrl('media/Product-Placeholder-Default-20210415.jpg');
    }

    return path.indexOf('https') > -1 ? path : Assets.baseCatalogPath() + path;
  }

  static getFundImage(fundName, type) {
    const url = `funds/${fundName}/${type}.png`;
    return Assets.getUrl(url);
  }

  static checkImageSize(path) {
    if (!path) {
      return;
    }

    const IMAGE_SIZE_QUERY = '?fit=fill&bg=FFFFFF&w=1400&h=1000&trim=color';

    if (path && path.includes('?')) {
      return path;
    }

    return `${path}${IMAGE_SIZE_QUERY}`;
  }
}
